export const GLOBALS = '__GLOBAL_STYLES__';

export const globalExtension = {
  selectorHandler: (selector: string, baseSelector: string, generateSubtreeStyles: (value: string) => string) => {
    return baseSelector.includes(GLOBALS) ? generateSubtreeStyles(selector) : null;
  },
};
